import React from 'react';

import { BackportingEnums } from '../../../../../../generated/compat/backportingEnums';
import { LiquidityRatiosInfo } from '../../../../../../generated/model/models';
import MatrixDataTable from '../../shared/MatrixDataTable';

export interface Props {
  data?: LiquidityRatiosInfo[];
  ccy?: BackportingEnums.CcyEnum;
}

const TABLE_FIELDS = ['ebitdaDebtRatio', 'liquidityRatio', 'solvencyRatio', 'stockCostOfGoodsSold'];

const LiquidityRatios: React.FC<Props> = ({ data, ccy }) => {
  return (
    <MatrixDataTable
      title={'liquidityRatios'}
      translationsScope={'companies:companyRatios'}
      data={data}
      tableFields={TABLE_FIELDS}
      ccy={ccy}
    />
  );
};

export default LiquidityRatios;
